import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';
import Artboard from 'components/Artboard';
import { AppRoute } from 'const';
import ArtboardPreview from 'containers/ArtboardPreview';
import {
  artboardImagesLoaded as artboardImagesLoadedAction,
  artboardMounted as artboardMountedAction,
  artboardWillBeMounted as artboardWillBeMountedAction,
} from 'containers/Artboards/actions';
import { artboardContainerSelector } from './selectors';
import { useArtboardDropTarget } from './useArtboardDropTarget';

const ArtboardContainer: React.FunctionComponent<RouteComponentProps> = ({ match }) => {
  const dispatch = useDispatch();
  const { connectDropTarget, isOver } = useArtboardDropTarget();
  const artboardImagesLoaded = useCallback(() => {
    return dispatch(artboardImagesLoadedAction());
  }, [dispatch]);

  const artboardMounted = useCallback(() => {
    return dispatch(artboardMountedAction());
  }, [dispatch]);

  const artboardWillBeMounted = useCallback(() => {
    return dispatch(artboardWillBeMountedAction());
  }, [dispatch]);

  const actions = useMemo(() => ({
    artboardImagesLoaded,
    artboardMounted,
    artboardWillBeMounted,
  }), [artboardImagesLoaded, artboardMounted, artboardWillBeMounted]);

  const selectorProps = useSelector(artboardContainerSelector);

  const props = useMemo(() => ({
    connectDropTarget,
    isOver,
    ...selectorProps,
    ...actions,
  }) as const, [connectDropTarget, isOver, selectorProps, actions]);

  return (
    <>
      <Route path={`${match.path}/${AppRoute.PREVIEW}/:screenId`} component={ArtboardPreview}/>
      <Artboard {...props} />
    </>
  );
};

export default withRouter(ArtboardContainer);
